import Accordion, { accordionClasses } from '@mui/material/Accordion';
import { styled } from '../styled';
var expansionPanelComponentName = 'QuantumExpansionPanel';
export var ExpansionPanel = styled(Accordion, { name: expansionPanelComponentName, slot: 'Root' })(function (_a) {
    var _b;
    var theme = _a.theme;
    return _b = {
            margin: 0,
            padding: theme.spacing(4),
            border: "1px solid ".concat(theme.tokens.color_border_default),
            boxShadow: 'none',
            position: 'relative',
            backgroundImage: 'none'
        },
        _b["&.".concat(accordionClasses.expanded)] = {
            margin: 0,
        },
        _b["&.".concat(accordionClasses.rounded)] = {
            borderRadius: 6,
        },
        _b;
});
